interface MicrosoftIconProps {
  className?: string;
}

/** The four-square Microsoft mark — shared by the login buttons and the IAM auth-provider badge. */
export function MicrosoftIcon({ className }: MicrosoftIconProps) {
  return (
    <svg className={className} viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <rect x="1" y="1" width="9" height="9" fill="#F25022" />
      <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
      <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
      <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
    </svg>
  );
}
